import React from 'react';
import { ConditionStatus } from '../types';
import { CircleDot, Send, Inbox, Eye, CheckCircle2, Ban, MinusCircle } from 'lucide-react';
interface StatusBadgeProps {
  status: ConditionStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const getStatusStyles = (status: ConditionStatus) => {
    switch (status) {
      case 'Need':
        return 'bg-amber-100 text-amber-800 border-amber-200';
      case 'Requested':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'Received':
        return 'bg-teal-100 text-teal-800 border-teal-200';
      case 'Review':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'Cleared':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'Waived':
      case 'N/A':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  const getStatusIcon = (status: ConditionStatus) => {
    switch (status) {
      case 'Need':
        return <CircleDot className="w-3 h-3 mr-1" data-id="element-233" />;
      case 'Requested':
        return <Send className="w-3 h-3 mr-1" data-id="element-234" />;
      case 'Received':
        return <Inbox className="w-3 h-3 mr-1" data-id="element-235" />;
      case 'Review':
        return <Eye className="w-3 h-3 mr-1" data-id="element-236" />;
      case 'Cleared':
        return <CheckCircle2 className="w-3 h-3 mr-1" data-id="element-237" />;
      case 'Waived':
        return <Ban className="w-3 h-3 mr-1" data-id="element-238" />;
      case 'N/A':
        return <MinusCircle className="w-3 h-3 mr-1" data-id="element-239" />;
      default:
        return <MinusCircle className="w-3 h-3 mr-1" data-id="element-240" />;
    }
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyles(status)}`} data-id="element-241">
      {getStatusIcon(status)}
      {status}
    </span>;
}